import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useWishlist } from "../context/WishlistContext";

export default function ProductCard({ product, showPriceLabel = false, linkTo, ctaLabel = "View product" }) {
  const { has, toggle } = useWishlist();
  const saved = has(product.slug);
  const to = linkTo || `/shop/${product.slug}`;

  return (
    <div className="group block bg-white rounded-2xl overflow-hidden hover-lift border border-[color:var(--dms-navy)]/5 relative">
      <button onClick={(e) => { e.preventDefault(); toggle(product); }}
        className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white/90 backdrop-blur border border-[color:var(--dms-navy)]/10 flex items-center justify-center transition-colors hover:bg-white"
        aria-label={saved ? "Remove from wishlist" : "Save to wishlist"}>
        <Heart className={`w-4 h-4 ${saved ? "fill-red-500 text-red-500" : "text-[color:var(--dms-navy)]/60"}`} />
      </button>
      <Link to={to} className="block">
        <div className="aspect-[1/1] bg-[color:var(--dms-peach-light)]/40 overflow-hidden">
          <img src={product.img} alt={product.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        </div>
        <div className="p-5">
          <p className="kicker text-[11px]">{product.category}</p>
          <h3 className="font-serif text-xl mt-2 text-[color:var(--dms-navy)] leading-snug">{product.title}</h3>
          {product.desc && (
            <p className="mt-2 text-sm text-[color:var(--dms-navy)]/60">{product.desc}</p>
          )}
          <div className="mt-4 flex items-center gap-2">
            {product.swatches?.map((s, i) => (
              <span key={i} className="swatch" style={{ background: s.hex || s }} />
            ))}
            <span className="text-xs text-[color:var(--dms-navy)]/60 ml-1">{product.swatches?.length} colors</span>
          </div>
          <p className="mt-3 text-[11px] tracking-widest text-[color:var(--dms-navy)]/60 uppercase">Sizes S–3XL</p>
          <div className="mt-4">
            {showPriceLabel && <p className="text-[11px] tracking-widest uppercase text-[color:var(--dms-navy)]/60">Starting at</p>}
            <p className="font-serif text-2xl text-[color:var(--dms-navy)]">{product.price}</p>
          </div>
          <div className="mt-5 w-full py-3 rounded-full border border-[color:var(--dms-navy)]/20 text-[11px] tracking-[0.18em] uppercase font-semibold text-[color:var(--dms-navy)] text-center group-hover:bg-[color:var(--dms-navy)] group-hover:text-white group-hover:border-[color:var(--dms-navy)] transition-colors">
            {ctaLabel}
          </div>
        </div>
      </Link>
    </div>
  );
}
